import Layout from "@/components/feature/Layout";
import SectionHeader from "@/components/base/SectionHeader";
import CTAButton from "@/components/base/CTAButton";
import WebsiteOrSoftware from "@/pages/home/components/WebsiteOrSoftware";
import Approach from "@/pages/home/components/Approach";
import ProductLab from "@/pages/home/components/ProductLab";
import FinalCta from "@/pages/home/components/FinalCta";

const progression = [
  { label: "Website", desc: "Your online presence" },
  { label: "Software", desc: "Custom systems" },
  { label: "Automation", desc: "Work smarter" },
  { label: "AI", desc: "Intelligent features" },
  { label: "Digital Transformation", desc: "Connected future" },
];

export default function Solutions() {
  return (
    <Layout>
      <div className="pt-16 md:pt-[72px]">
        <section className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-20 bg-background-100">
          <div className="mx-auto max-w-[1280px]">
            <SectionHeader
              eyebrow="Solutions"
              title="One partner, from website to complete digital platform."
              subtitle="Whether you're starting with a website or need a full digital system, we meet you where you are and help you grow."
            />
          </div>
        </section>

        {/* Progression */}
        <section className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-20">
          <div className="mx-auto max-w-[1280px]">
            <SectionHeader
              eyebrow="The Journey"
              title="Where we can take your organization."
            />
            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
              {progression.map((p, i) => (
                <div
                  key={p.label}
                  className="relative rounded-lg border border-background-200 bg-background-50 p-6 text-center transition-all duration-300 hover:border-primary-300"
                >
                  <span className="font-heading text-3xl font-bold text-primary-200">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <h3 className="mt-2 font-heading text-lg font-semibold text-foreground-950">
                    {p.label}
                  </h3>
                  <p className="mt-1 text-sm text-foreground-600">{p.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <WebsiteOrSoftware />

        <Approach />

        <ProductLab />

        <FinalCta />
      </div>
    </Layout>
  );
}